/**
 * Экраны для гостя: вход, «Забыли пароль?», настройка по ссылке приглашения или сброса.
 * 401 на них — обычное состояние без сессии, а не повод уводить на вход: иначе ссылка
 * настройки не открывается (запрос профиля для языка интерфейса получает 401).
 */
const GUEST_PATHS = ['/login', '/forgot-password', '/setup'] as const;

export function isGuestPath(pathname: string): boolean {
  return GUEST_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}
